import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { DocumentCreationModalComponent } from './document-creation-modal.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    declarations: [
        DocumentCreationModalComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        FormsModule,
        MatSelectModule,
        MatIconModule,
        MatRadioModule,
        TranslateModule.forChild()
    ],
    exports: [
        DocumentCreationModalComponent
    ],
    entryComponents: [
        DocumentCreationModalComponent
    ]
})
export class DocumentCreationModalModule {}
